import React from 'react';
import Seo from '../../components/utils/Seo';
import BodySpecificContact from './body/BodySpecificContact'
import Footer from '../../components/marketing/footer/Footer';
import NavBar from '../../components/marketing/navbar/NavBar';

function SpecificContact(props) {
    return (
        <div className="selection:bg-primary selection:text-white">
            <Seo
                title="contact spécifique"
                description="Rita nsangou est la solution pour tout vos problèmes de traduction. français-anglais-espagnol"
            />
            <NavBar classe="fixed top-0 w-full z-50 bg-white pb-2" />
            <BodySpecificContact />
            <Footer />
        </div>
    );
}

export default SpecificContact;